import { Col, Container, Modal, Row } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import FooterNew from '../components/Footer'
import Navigation from '../components/Navigation'
import { useStore } from '../../app/stores/store'
import PostImagesSwiper from '../components/PostImagesSwiper'
import GoogleMapComp from '../components/GoogleMapComp'
import DeletePopup from '../components/DeletePopup'
import { history } from '../..'
import { FilterModes } from '../../app/models/modes'
import PostEdit from './PostEdit'
import PostDetailsContact from '../components/post/PostDetailsContact'
import { currencyValue, formatCurrency } from '../components/muiStyle/muiStyle'
import ComponentLoader from '../components/loaders/ComponentLoader'
import { PostStatus } from '../../app/models/Post'
import DeletedItemModal from '../components/DeletedItemModal'
import Advertisment from '../components/advertisment/Advertisment'
import CustomBar from '../components/custombar/CustomBar'

function PostDetails() {
  const { postListStore, methodsStore, postStore, userStore, favoriteAuctionsStore } = useStore()
  const { postDetails, postById } = postListStore
  const { selectedCurrency } = methodsStore
  const { t } = useTranslation()
  const { showDelete, setShowDelete, showEditPost, closeShowEditPost } = methodsStore
  const page: any = useParams()
  const [loadingBtn, setLoadingBtn] = useState(false)
  const [loadingInitial, setLoadingInitial] = useState(true)
  const { addFavorite, removeFavorite, findFavorite } = favoriteAuctionsStore
  const location = useLocation()

  useEffect(() => {
    setLoadingInitial(true)
    postById(page.id).finally(async () => {
      await new Promise((resolve) => setTimeout(resolve, 400))
      setLoadingInitial(false)
    })
  }, [postListStore, page.id, postById])

  if (loadingInitial) return <ComponentLoader mTop={100} />

  function handleDelete() {
    setLoadingBtn(true)
    postStore
      .deletePosts(page.id!)
      .then(() => {
        history.push('/posts')
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setShowDelete(false)

        setLoadingBtn(false)
      })
  }

  const handleAddFav = () => {
    if (!userStore.isLoggedIn) {
      toast.error(t('err_login'))
    } else {
      setLoadingBtn(true)
      addFavorite(page.id!, FilterModes.post).finally(() => setLoadingBtn(false))
    }
  }

  const handleRemoveFav = () => {
    setLoadingBtn(true)
    removeFavorite(page.id!, postDetails?.title as string, FilterModes.post).finally(() =>
      setLoadingBtn(false),
    )
  }

  const favButtons = [
    {
      icon: 'fa-regular fa-heart',
      onClick: handleAddFav,
      show: !findFavorite(page.id!),
    },
    {
      icon: 'fa-solid fa-heart',
      onClick: handleRemoveFav,
      show: findFavorite(page.id!),
    },
  ]

  const goBack = () => {
    history.push('/posts')
  }

  const fullUrl =
    window.location.origin +
    location.pathname +
    location.search +
    location.hash;

  const currencyName = currencyValue.find((item) => item.value === postDetails?.currency)?.name

  return (
    <>
      <Navigation type={FilterModes.post} postStatus={postDetails?.status} />
      <Container fluid className='post-details-container'>
        <Row className='post-details'>
          <Col xxl={9} className='post-details-content'>
            <div className='post-details-navigation'>
              <p onClick={goBack}>← {t('go_back')}</p>
              {/* <p>Nächstes Objekt →</p> */}
            </div>
            <div className='post-details-image'>
              <PostImagesSwiper
                details
                id={postDetails?.id as string}
                postImages={postDetails?.postImages || []}
                favButtons={favButtons}
                slug={postDetails?.slug || ''}
                loadingFavBtn={loadingBtn}
                postStatus={postDetails?.status}
              />
            </div>
            <div className='post-details-header'>
              <h1>{postDetails?.title}</h1>
              <div>
                <h6>{t('share_opts')}: </h6>
                <div className='share-options'>
                  <FacebookShareButton resetButtonStyle={false} url={fullUrl}>
                    <i className='fa-brands fa-facebook-f' />
                  </FacebookShareButton>
                  <TwitterShareButton
                    resetButtonStyle={false}
                    url={fullUrl}
                    title={postDetails?.title}
                  >
                    <i className='fa-brands fa-twitter' />
                  </TwitterShareButton>
                  <WhatsappShareButton resetButtonStyle={false} url={fullUrl}>
                    <i className='fa-brands fa-whatsapp' />
                  </WhatsappShareButton>
                </div>
              </div>
            </div>
            <hr className='auction-card-line' />
            <Advertisment />
            <hr className='auction-card-line' />
            <CustomBar />
            <hr className='auction-card-line' />
            <div className='post-details-map'>
              <p>
                {postDetails?.address}, {postDetails?.city} {postDetails?.zipCode}
              </p>
              <GoogleMapComp
                address={postDetails?.address as string}
                zipCode={postDetails?.zipCode as number}
                city={postDetails?.city as string}
                height={525}
              />
            </div>
            <hr className='auction-card-line' />

            <Container className='post-details-main-info'>
              <Row className='align-items-end'>
                <Col md={4}>
                  <h2>{t('main_info')}</h2>
                  <p>{t('room')}</p>
                  <p>{t('availability')}</p>
                  <p>{t('category')}</p>
                  {postDetails?.userCompanyName && <p>Company Name</p>}
                </Col>
                <Col className='fw-bold'>
                  <p>{postDetails?.rooms}</p>
                  <p>{postDetails?.meters} m²</p>
                  <p>{postDetails?.category}</p>
                  {postDetails?.userCompanyName && (
                    <p>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href={postDetails.userCompanyUrl}
                      >
                        {postDetails?.userCompanyName}
                      </a>
                    </p>
                  )}
                </Col>
              </Row>
            </Container>
            <hr className='auction-card-line' />
            <Container className='post-details-main-info'>
              <Row className='align-items-end'>
                <Col md={4}>
                  <h2>{t('price')}</h2>
                  <p>{t('property_price')}</p>
                  <p>{t('appraised_value')}</p>
                  {/* <p>Bruttomiete (Monat)</p>
                      <p>Mietkautionsbescheinigung</p> */}
                </Col>
                <Col className='fw-bold '>
                  <div className='d-flex post-currencies'>
                    <p>
                      {postDetails?.price
                        ? `${currencyName} ${formatCurrency(postDetails.price)}`
                        : t('only_for_auction')}
                    </p>
                    {postDetails?.price !== 0 && selectedCurrency !== currencyName && (
                      <>
                        <span className='hide-equal'>≈</span>
                        <p>
                          {`${selectedCurrency} ${formatCurrency(postDetails?.convertedPrice)}`}
                        </p>
                      </>
                    )}
                  </div>
                  <p>{t('not_defined')}</p>
                  {/* <p>Verfügbarkeit</p>
                      <p className="greenColor text-decoration-underline">
                        Bescheinigung beantragen
                      </p> */}
                </Col>
              </Row>
            </Container>
            <hr className='auction-card-line' />
            <Container className='post-details-main-info'>
              <Row className='align-items-end'>
                <Col md={10}>
                  <h2>{t('desc')}</h2>
                  <p>{postDetails?.description}</p>
                </Col>
              </Row>
            </Container>
            <hr className='auction-card-line' />
            <Container className='post-details-main-info'>
              <Row className='align-items-end'>
                <Col md={4}>
                  <h2>{t('ameneties')}</h2>
                  {postDetails?.tags.map((tag, index) => (
                    <div key={index} className='d-flex justify-content-between align-items-center'>
                      <p>{t(`auction_tag.${tag.tag.toLowerCase()}`)}</p>
                      <p>
                        <i className='fa-solid fa-check' />
                      </p>
                    </div>
                  ))}
                </Col>
              </Row>
            </Container>
            <hr className='auction-card-line' />
            <button
              onClick={() => {
                window.scrollTo({
                  top: 200,
                  behavior: 'smooth',
                })
              }}
              className='post-details-contact-btn'
            >
              {t('contact_provider')}
            </button>
          </Col>
          <Col xxl={3} className='post-contact-card ps-0 pe-0'>
            <PostDetailsContact />
          </Col>
        </Row>
      </Container>
      <FooterNew />

      {/* Auction Delete Modal */}
      <Modal size='lg' centered show={showDelete} onHide={() => setShowDelete(false)}>
        <DeletePopup
          handleClose={() => setShowDelete(false)}
          handleDelete={handleDelete}
          loadingBtn={loadingBtn}
          title={t('post')}
        />
      </Modal>

      <Modal size='lg' centered show={showEditPost} onHide={() => closeShowEditPost()}>
        <PostEdit handleClosePost={() => closeShowEditPost()} />
      </Modal>

      {postDetails?.status === PostStatus.Deleted && !methodsStore.isPostCreator() && (
        <DeletedItemModal type={FilterModes.post} />
      )}
    </>
  )
}
export default observer(PostDetails)
